import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams, useNavigate } from 'react-router-dom';

import { getToptipp } from '../helper/restapi.js';
import { Loader } from './Loader.js';
import { Banner, FormFree } from './Elements.js';

export default function TopTipp() {
	const { id } = useParams();
	const navigate = useNavigate();
	const [data, setData] = useState(null);
	const [isReady, setIsReady] = useState(false);
	const [formOpen, setFormOpen] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await getToptipp(id);
				const toptipp = response?.data?.data ?? null;

				if (!toptipp || toptipp.status === 404) {
					navigate('/seite-nicht-gefunden', { replace: true });
					return;
				}

				setData(toptipp);
				setIsReady(true);
			} catch (error) {
				console.error('Error fetching toptipp:', error);
				navigate('/seite-nicht-gefunden', { replace: true });
			}
		};

		fetchData();
	}, [id, navigate]);

	if (!isReady || !data) {
		return <Loader />;
	}

	const bannerData = {
		slogan: data.title,
		short: data.short,
		image: data.image,
		image_banner: null,
		image_small: false,
		contact: false,
		...(data.form
			? { onAction: () => setFormOpen(true), actionLabel: 'Teilnehmen' }
			: { slug: data.slug }
		),
	};

	const today = new Date();
	const todayYmd = today.getFullYear() * 10000 + (today.getMonth() + 1) * 100 + today.getDate();

	const tipps = (Array.isArray(data.tipps) ? data.tipps : [])
		.filter(tipp => !tipp.date || parseInt(tipp.date, 10) <= todayYmd);

	return (
		<>
			<Helmet>
				<title>{data.meta_title || data.title}</title>
				{data.meta_description && <meta name="description" content={data.meta_description} />}
				{data.social_title && <meta property="og:title" content={data.social_title} />}
				{data.social_description && <meta property="og:description" content={data.social_description} />}
				{data.social_image && <meta property="og:image" content={data.social_image} />}
			</Helmet>

			<Banner data={bannerData} />

			{tipps.length > 0 && (
				<div className="post-list">
					<div className="container">
						<div className="row">
							{tipps.map((tipp, index) => (
								<div key={index} className="col-12 col-sm-6 col-lg-4 post">
									<a href={tipp.link} title={tipp.title} target="_blank" rel="noreferrer">
										<div className="inner">
											{tipp.image?.sizes?.['news-list'] && (
												<img src={tipp.image.sizes['news-list']} alt={tipp.title} />
											)}
											<div className="info">
												<h3>{tipp.title}</h3>
												<div>{tipp.subtitle}</div>
											</div>
											<span>Tipp</span>
										</div>
									</a>
								</div>
							))}
						</div>
					</div>
				</div>
			)}

			{data.form && (
				<>
					<div
						className={`toptipp-form-overlay${formOpen ? ' open' : ''}`}
						onClick={() => setFormOpen(false)}
					/>
					<div className={`toptipp-form-drawer${formOpen ? ' open' : ''}`}>
						<button className="toptipp-form-close" onClick={() => setFormOpen(false)}>✕</button>
						<FormFree id={data.form} />
					</div>
				</>
			)}
		</>
	);
}
